const breakpoints = {
  tablet: 768,
  desktop: 1200,
  bigscreen: 1440,
};
let currentBreakpoint = '';
let isMobile;

const updateCurrentBreakpoint = () => {
  if (window.innerWidth >= breakpoints.bigscreen) {
    currentBreakpoint = 'bigscreen';
    return;
  }
  if (window.innerWidth >= breakpoints.desktop) {
    currentBreakpoint = 'desktop';
    return;
  }
  if (window.innerWidth >= breakpoints.tablet) {
    currentBreakpoint = 'tablet';
    return;
  }
  currentBreakpoint = 'smartphone';
};

const updateIsMobile = () => {
  isMobile =
    currentBreakpoint !== 'desktop' && currentBreakpoint !== 'bigscreen';
};

const updateBreakpointInfo = () => {
  updateCurrentBreakpoint();
  updateIsMobile();
};

window.addEventListener('resize', updateBreakpointInfo);

updateBreakpointInfo();

export { breakpoints, currentBreakpoint, isMobile };
